export const positions = {
    GET_POSITIONS_REQUEST: 'GET_POSITIONS_REQUEST',
    GET_POSITIONS_SUCCESS: 'GET_POSITIONS_SUCCESS',
    GET_POSITIONS_ERROR: 'GET_POSITIONS_ERROR',
  };